import React from 'react';
import { translate } from '../../ContentTranslation';
import './ArtworkNotification.css';

export default function ArtworkNotification() {
  return <span className="artwork-notification" role="img" aria-label={translate("New card artwork unlocked")}>!</span>;
}
